export type Tenant = "praxis" | "testcontext";

export function detectTenant(hostname = window.location.hostname): Tenant {
  const h = (hostname || "").toLowerCase();
  return h.startsWith("testcontext.") || h.includes("testcontext") ? "testcontext" : "praxis";
}

export function tenantBrand(tenant: Tenant) {
  return tenant === "testcontext"
    ? {
        name: "TestContext",
        tagline: "Experiment, learn fast, and refine your practice.",
      }
    : {
        name: "Praxis",
        tagline: "Practice negotiation and influence until it becomes instinct.",
      };
}
